<style lang="css" scoped>

</style>

<template>

  <v-layout row justify-center v-if="status">
      <v-dialog v-model="dialog" persistent max-width="350">
        <v-card>
          <v-card-title primary-title class="orange lighten-3">
            <h2>
              {{content.title}}
            </h2>
          </v-card-title>
          <v-card-text>
            {{content.body1}}<br>
            {{content.body2}}
          </v-card-text>
          <v-card-actions>
            <v-layout row column align-start>
              <v-btn color="blue darken-4" flat @click="action(1)">{{content.btn_new}}</v-btn>
              <v-btn color="blue darken-1" flat @click="action(2)">{{content.btn_default}}</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

</template>

<script>

export default {
    props: ['status', 'slug'],
    data() {
        return {
          dialog: false,
        }
    },
    created() {
      this.setLang();
      this.dialog = this.status;
    },
    watch: {
      status(){
        this.dialog = this.status;
      },
      slug(){
        this.dialog = this.status;
      },
    },
    methods: {
      action(answer){
        this.$emit('reqScheduleEvent', answer);
        this.dialog = false;
      },

      setLang(){
        let locale = Lang.get();
        if (locale == 'en') {
          this.content = {
            title: 'A schedule is required',
            body1: 'Unspecified schedule on the device.',
            body2: 'In "automatic" mode without a schedule the device will remain off!',
            btn_new: 'Add a new schedule',
            btn_default: 'Add a default schedule',
          }
        } else if (locale == 'he') {
          this.content = {
            title: 'נדרש להזין לוח זמנים',
            body1: 'לוח זמנים לא מוגדר במכשיר.',
            body2: 'במצב "אוטומט" ללא לוח זמנים המכשיר יישאר כבוי!',
            btn_new: 'הוסף לוח זמנים חדש',
            btn_default: 'הוסף לוח זמנים ברירת מחדל',
          }
        }
      }
    }
}

</script>
